import React from 'react';
import { StarIcon } from 'lucide-react';
import { Card } from './ui/Card';
import { motion } from 'framer-motion';
export function Testimonials() {
  const testimonials = [{
    id: 1,
    name: 'Franco M.',
    info: '22 años, Buenos Aires',
    text: 'Me ayudó a ordenar mi preparación mucho más de lo que esperaba. Antes estaba perdido y no sabía por dónde empezar. Con el pack pude enfocarme mejor y practicar con más seguridad.'
  }, {
    id: 2,
    name: 'Luciano R.',
    info: '24 años, Córdoba',
    text: 'Lo que más valoré fue tener todo junto. Psicotécnico, entrevista, simulacros y entrenamiento. Me ahorró muchísimo tiempo.'
  }, {
    id: 3,
    name: 'Agustín P.',
    info: '21 años, Mendoza',
    text: 'Sentí que llegué mucho más preparado. Antes tenía nervios porque no sabía cómo eran las etapas. Este material me dio mucha más confianza.'
  }, {
    id: 4,
    name: 'Nicolás S.',
    info: '23 años, Rosario',
    text: 'Muy completo. No es solo teoría, también te ayuda a entrenarte mentalmente para el proceso.'
  }, {
    id: 5,
    name: 'Matías D.',
    info: '20 años, Tucumán',
    text: 'Arranqué sin saber nada del proceso y este pack me dio una estructura clara. Lo recomiendo a cualquiera que quiera tomarse en serio la preparación.'
  }];
  return <section className="py-5 px-4 sm:px-6 lg:px-8 bg-gray-900 border-t border-gray-800" data-id="element-194">
      <div className="max-w-5xl mx-auto" data-id="element-195">
        <div className="text-center mb-4" data-id="element-196">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-1" data-id="element-197">
            Lo que dicen otros aspirantes
          </h2>
          <div className="flex justify-center gap-0.5" data-id="element-198">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-green-500 fill-green-500" data-id="element-199" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-200">
          {testimonials.map((t, index) => <motion.div key={t.id} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className={index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''} data-id="element-201">
              <Card className="p-4 h-full bg-black border-gray-800 flex flex-col" data-id="element-202">
                <div className="flex gap-0.5 mb-1" data-id="element-203">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 text-green-500 fill-green-500" data-id="element-204" />)}
                </div>
                <p className="text-gray-300 text-sm italic mb-3 flex-grow" data-id="element-205">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-206">
                  <div className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center border border-gray-700" data-id="element-207">
                    <span className="text-green-500 font-bold text-sm font-heading" data-id="element-208">
                      {t.name.charAt(0)}
                    </span>
                  </div>
                  <div data-id="element-209">
                    <h4 className="text-white font-bold text-sm" data-id="element-210">{t.name}</h4>
                    <p className="text-xs text-gray-500" data-id="element-211">{t.info}</p>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}